import { useEffect, useRef, useState } from 'react';

/**
 * Lightweight scroll-into-view hook (framer-motion v4 has no whileInView).
 * Returns [ref, inView]; inView flips true once when the element enters
 * the viewport and stays true (one-shot reveal).
 */
export default function useInView({ amount = 0.2, once = true } = {}) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    if (typeof IntersectionObserver === 'undefined') {
      setInView(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          if (once) observer.disconnect();
        } else if (!once) {
          setInView(false);
        }
      },
      { threshold: amount }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [amount, once]);

  return [ref, inView];
}
